import { gql } from "@apollo/client"

export const GET_FORM_QUERY = gql`
    query FormTemplate($id: MongoID!) {
        formTemplate(_id: $id) {
            name
            schema
            description
            fieldAlertConditions {
                fieldName
                conditions {
                    type
                    _id
                }
                alertLevel
            }
        }
    }
`
